"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploaderViewModes = void 0;
var UploaderViewModes = {
  PICTURE_CARD: 'PICTURE_CARD',
  LABELLED_CARD: 'LABELLED_CARD'
};
exports.UploaderViewModes = UploaderViewModes;